import Link from './view';

// Link has the same props as the <a /> tag.

export default Link;
